import { IDataPoint } from './AbstractPanel';
import * as React from 'react';
import { computed } from 'mobx';
import { Scan } from '../../../data_layer/models/Scan';
import { ScanStore } from '../../../data_layer/stores/ScanStore';
import { AreaGraph } from '../Graphs/AreaGraph';
import { CONSTANTS } from '../../../assets/UIConstants';
import { CurrentValue } from '../CurrentValue';

interface MiniGraphProps {
    scanStore: ScanStore;
    color?: string;
    paddingTop: number;
}

export abstract class AbstractMiniGraph extends  React.Component<MiniGraphProps> {
    protected currentScan: Scan = this.props.scanStore.latestScanInDisplayRange;

    @computed protected get graphDataPoints(): IDataPoint[] {
        const dataPoints: IDataPoint[] = [];
        this.props.scanStore.recentScans.map((scan: Scan) => {
            const tmp: IDataPoint = {
                x: scan.created_at.valueOf(),
                y: this.yValueExtractor(scan),
            };
            dataPoints.push(tmp);
        });
        return dataPoints;
    }

    @computed protected get currentValue(): number {
        return this.yValueExtractor(this.currentScan);
    }

    protected abstract yValueExtractor(scan: Scan): number;

    public render(): JSX.Element {
        return (
            <div style={{paddingLeft: 20}}>
                <div style={{paddingTop: this.props.paddingTop}}>
                    <AreaGraph
                        width={180}
                        height={60}
                        dataPoints={this.graphDataPoints}
                        accentColor={this.props.color || CONSTANTS.COLORS.THEME_BLUE}
                        hasGrid={false}
                        dotRadius={2}
                    />
                </div>
                <div style={{paddingTop: 5}}>
                    <CurrentValue
                        value={this.currentValue}
                        valueFontSize={26}
                        unitFontSize={16}
                    />
                </div>
            </div>
        );
    }
}

export class LeftArmMiniGraph extends AbstractMiniGraph {
    protected yValueExtractor(scan: Scan): number {
        return scan.scan_results.fatFreeMassPoundsLeftArm;
    }
}
export class RightArmMiniGraph extends AbstractMiniGraph {
    protected yValueExtractor(scan: Scan): number {
        return scan.scan_results.fatFreeMassPoundsRightArm;
    }
}
export class LeftLegMiniGraph extends AbstractMiniGraph {
    protected yValueExtractor(scan: Scan): number {
        return scan.scan_results.fatFreeMassPoundsLeftLeg;
    }
}
export class RightLegMiniGraph extends AbstractMiniGraph {
    protected yValueExtractor(scan: Scan): number {
        return scan.scan_results.fatFreeMassPoundsRightLeg;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/components/dashboardPanels/MiniGraphs.tsx